"use strict";

/**
 * Обработка ответа reCaptcha
 * @param {any} response
 */
function checkCaptchaResponce(response) {
  $.ajax({
    type: "GET",
    url: "/Account/GetCaptchaResponce",
    data: {
      response: response
    },
    success: function success(r) {
      var captchaResponse = jQuery.parseJSON(r.Response);
      // проверяем включена ли капча
      if (captchaResponse.success) {
        $("#submitLoginId").prop("disabled", false);
      }
    }
  });
}

/** Колбэк загрузки капчи, если она не нужна */
function onCaptchaEmptyCallback() {
  console.log("captcha is hidden");
}